export default __webpack_public_path__ + "static/media/lv9.9830d7bc.png";